import AnchorAPIError from '../../AnchorAPIError';

export type FetchCurrentPodcastWalletResponse = {
  hasEverActivatedCampaign: boolean;
  isStripeOnboardingCompleted: boolean;
  currentWalletAmountInCents: number;
  pendingWalletAmountInCents: number;
  allTimeWalletAmountInCents: number;
  allTimeWalletBreakdown?: {
    amount: number;
    anchorFee: number;
    net: number;
    paid: number;
    processorFee: number;
    payoutFee: number;
    totalAllTimeEarned: number;
  };
  normalPayoutProcessingFeeInCents: number;
  instantPayoutProcessingFeeInCents: number;
  isPayoutEnabled: boolean;
  isInstantPayoutAvailable: boolean;
  areStripeRequirementsMet: boolean;
  doShowActivateAllButton: boolean;
  lastPayout: {
    amount: number;
    createdUnixTimestamp: number;
    currency: string;
  } | null;
  stripeDashboardURL: string | null;
  w8CollectionRequired: boolean;
  currency: string | null;
  minimumCashoutAmount: number; // In cents
};

const fetchCurrentPodcastWallet = ({ shouldBustCache = false } = {}) =>
  new Promise<FetchCurrentPodcastWalletResponse>((resolve, reject) => {
    const baseUrlPath = '/api/proxy/v3/wallet';
    const urlPath = shouldBustCache
      ? `${baseUrlPath}?${Date.now()}`
      : baseUrlPath;
    fetch(urlPath, {
      credentials: 'same-origin',
      method: 'GET',
    }).then((response: any): void => {
      if (response.ok) {
        response.json().then((responseJson: any) => {
          resolve(responseJson);
        });
      } else {
        const error = new AnchorAPIError(response, 'Server error.');
        reject(error);
      }
    });
  });

export { fetchCurrentPodcastWallet };
